import { CONTRACTORS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/contractors_private_network_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['contractorPrivateNetworksIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState, 'supplierFacility.id');
